/*
 * "Edit this article" - a link from an article's page to the same article in the
 * admin editor, in the sidebar just above "Signed in as" (owner's request,
 * 2026-11-04).
 *
 * Shown on exactly the rule the header's "Manage" follows (SiteNav.tsx): the
 * server has confirmed this reader may administer (identity.isAdmin, from
 * /api/admin/me). So, like Manage, it appears a moment after the page, and never
 * for a reader the admin site would turn away. It is a convenience, not a gate -
 * the admin site checks the reader again on arrival.
 *
 * The address is relative, /admin/articles/{id}, the admin editor's own route
 * (App.tsx), so it stays on whichever site the article was read on -
 * kb.accotool.com or the BIaaS site, TEST or PROD. The id is the article's, as
 * the server sent it, lowercased like every admin link to an article.
 *
 * useOptionalAuth rather than useAuth: the article page is also rendered
 * without the provider (tests), and outside it nobody is an administrator.
 */

import { Link } from 'react-router-dom';
import { useOptionalAuth } from '../auth/AuthProvider.js';
import { useMessages } from '../i18n/language.js';

export function EditArticleLink({ articleId }: { articleId: string }): JSX.Element | null {
  const auth = useOptionalAuth();
  const t = useMessages();
  if (auth?.identity?.isAdmin !== true) return null;

  return (
    <div className="sidebar-group">
      <Link to={`/admin/articles/${articleId}`}>{t.article.edit}</Link>
    </div>
  );
}
